// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Partner demo pages – formal, professional layout (full width) */
.partner-demo-page {
  margin-top: 100px;
  width: 100%;
  padding: 1.5rem 1.75rem 2rem;
  background: #f8faf9;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
}

.partner-demo-page .page-breadcrumb {
  font-size: 0.8125rem;
  color: #5a6b64;
  margin-bottom: 0.75rem;
}

.partner-demo-page .page-breadcrumb a {
  color: #1f7c50;
  text-decoration: none;
  font-weight: 500;
}

.partner-demo-page .page-breadcrumb a:hover {
  text-decoration: underline;
}

.partner-demo-page .page-header {
  border-bottom: 1px solid #e2e9e6;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
}

.partner-demo-page .page-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a2522;
  margin: 0 0 0.25rem 0;
  letter-spacing: -0.02em;
}

.partner-demo-page .page-subtitle {
  font-size: 0.9375rem;
  color: #5a6b64;
  margin: 0;
  font-weight: 400;
}

.partner-demo-page .card-partner {
  background: #fff;
  border: 1px solid #e2e9e6;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(26, 37, 34, 0.06);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.partner-demo-page .card-partner .card-header-partner {
  background: #f1f5f4;
  border-bottom: 1px solid #e2e9e6;
  padding: 0.875rem 1.25rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1a2522;
}

.partner-demo-page .card-partner .card-body-partner {
  padding: 1.25rem 1.5rem;
}

.partner-demo-page .table-partner {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375rem;
}

.partner-demo-page .table-partner thead th {
  background: #f1f5f4;
  color: #1a2522;
  font-weight: 600;
  text-align: left;
  padding: 0.75rem 1rem;
  border-bottom: 2px solid #e2e9e6;
  white-space: nowrap;
}

.partner-demo-page .table-partner tbody tr {
  border-bottom: 1px solid #e2e9e6;
  transition: background-color 0.15s ease;
}

.partner-demo-page .table-partner tbody tr:hover {
  background: #f8faf9;
}

.partner-demo-page .table-partner tbody td {
  padding: 0.875rem 1rem;
  color: #2d3d38;
  vertical-align: middle;
}

.partner-demo-page .badge-partner {
  display: inline-block;
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.partner-demo-page .badge-partner.badge-success {
  background: #e8f5ef;
  color: #0d5c3a;
}

.partner-demo-page .badge-partner.badge-warning {
  background: #fef8e8;
  color: #8a6a1e;
}

.partner-demo-page .badge-partner.badge-info {
  background: #e8f2f5;
  color: #1a5f7a;
}

.partner-demo-page .badge-partner.badge-secondary {
  background: #eef1f0;
  color: #5a6b64;
}

.partner-demo-page .badge-partner.badge-danger {
  background: #fce8e8;
  color: #a32a2a;
}

.partner-demo-page .btn-partner-primary {
  background: #1f7c50;
  border-color: #1f7c50;
  color: #fff;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
}

.partner-demo-page .btn-partner-primary:hover {
  background: #1a6b44;
  border-color: #1a6b44;
  color: #fff;
}

.partner-demo-page .btn-partner-outline {
  border: 1px solid #c5d4d0;
  color: #2d3d38;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  background: #fff;
}

.partner-demo-page .btn-partner-outline:hover {
  background: #f1f5f4;
  border-color: #a8bdb5;
  color: #1a2522;
}

.partner-demo-page .stat-card {
  background: #fff;
  border: 1px solid #e2e9e6;
  border-radius: 10px;
  padding: 1.25rem;
  box-shadow: 0 1px 3px rgba(26, 37, 34, 0.06);
  height: 100%;
}

.partner-demo-page .stat-card.stat-success {
  border-left: 4px solid #1f7c50;
}

.partner-demo-page .stat-card .stat-label {
  font-size: 0.8125rem;
  color: #5a6b64;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.partner-demo-page .stat-card .stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a2522;
}

.partner-demo-page .stat-card .stat-meta {
  font-size: 0.8125rem;
  color: #5a6b64;
  margin-top: 0.25rem;
}

.partner-demo-page .quick-link-card {
  display: block;
  text-decoration: none;
  background: #fff;
  border: 1px solid #e2e9e6;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-bottom: 0.5rem;
  color: #2d3d38;
  font-weight: 500;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.partner-demo-page .quick-link-card:hover {
  border-color: #1f7c50;
  background: #f8faf9;
  color: #1a2522;
}

.partner-demo-page .activity-item {
  padding: 0.75rem 0;
  border-bottom: 1px solid #e2e9e6;
  font-size: 0.9375rem;
  color: #2d3d38;
}

.partner-demo-page .activity-item:last-child {
  border-bottom: none;
}

.partner-demo-page .activity-item .activity-time {
  font-size: 0.8125rem;
  color: #5a6b64;
  margin-top: 0.2rem;
}

.partner-demo-page .form-label-partner {
  font-size: 0.875rem;
  font-weight: 500;
  color: #2d3d38;
  margin-bottom: 0.375rem;
}

.partner-demo-page .form-control-partner {
  border: 1px solid #c5d4d0;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  font-size: 0.9375rem;
}

.partner-demo-page .form-control-partner:focus {
  border-color: #1f7c50;
  box-shadow: 0 0 0 3px rgba(31, 124, 80, 0.15);
}

.partner-demo-page .cert-card {
  background: #fff;
  border: 1px solid #e2e9e6;
  border-radius: 10px;
  padding: 1.25rem;
  height: 100%;
  box-shadow: 0 1px 3px rgba(26, 37, 34, 0.06);
}

.partner-demo-page .cert-card .cert-name {
  font-size: 1rem;
  font-weight: 600;
  color: #1a2522;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e9e6;
}

.partner-demo-page .cert-card .cert-detail {
  font-size: 0.875rem;
  color: #5a6b64;
  margin-bottom: 0.25rem;
}

.partner-demo-page .cert-card .cert-detail strong {
  color: #2d3d38;
  font-weight: 500;
}

.partner-demo-page .list-item-partner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #e2e9e6;
  font-size: 0.9375rem;
}

.partner-demo-page .list-item-partner:last-child {
  border-bottom: none;
}

.partner-demo-page .section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1a2522;
  margin: 0 0 1rem 0;
}

.partner-demo-page .demo-badge {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #5a6b64;
  background: #eef1f0;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  margin-left: 0.5rem;
}

.partner-demo-page .partner-brief {
  background: #e8f5ef;
  border: 1px solid #c5e6d4;
  color: #1a2522;
}

.partner-demo-page .partner-brief strong {
  color: #0d5c3a;
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PartnerDemoPages.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,iBAAiB;EACjB,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Partner demo pages – formal, professional layout (full width) */\r\n.partner-demo-page {\r\n  margin-top: 100px;\r\n  width: 100%;\r\n  padding: 1.5rem 1.75rem 2rem;\r\n  background: #f8faf9;\r\n  min-height: calc(100vh - 60px);\r\n  box-sizing: border-box;\r\n}\r\n\r\n.partner-demo-page .page-breadcrumb {\r\n  font-size: 0.8125rem;\r\n  color: #5a6b64;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.partner-demo-page .page-breadcrumb a {\r\n  color: #1f7c50;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.partner-demo-page .page-breadcrumb a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.partner-demo-page .page-header {\r\n  border-bottom: 1px solid #e2e9e6;\r\n  padding-bottom: 1rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.partner-demo-page .page-title {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: #1a2522;\r\n  margin: 0 0 0.25rem 0;\r\n  letter-spacing: -0.02em;\r\n}\r\n\r\n.partner-demo-page .page-subtitle {\r\n  font-size: 0.9375rem;\r\n  color: #5a6b64;\r\n  margin: 0;\r\n  font-weight: 400;\r\n}\r\n\r\n.partner-demo-page .card-partner {\r\n  background: #fff;\r\n  border: 1px solid #e2e9e6;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 3px rgba(26, 37, 34, 0.06);\r\n  margin-bottom: 1.5rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.partner-demo-page .card-partner .card-header-partner {\r\n  background: #f1f5f4;\r\n  border-bottom: 1px solid #e2e9e6;\r\n  padding: 0.875rem 1.25rem;\r\n  font-size: 0.9375rem;\r\n  font-weight: 600;\r\n  color: #1a2522;\r\n}\r\n\r\n.partner-demo-page .card-partner .card-body-partner {\r\n  padding: 1.25rem 1.5rem;\r\n}\r\n\r\n.partner-demo-page .table-partner {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.9375rem;\r\n}\r\n\r\n.partner-demo-page .table-partner thead th {\r\n  background: #f1f5f4;\r\n  color: #1a2522;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 2px solid #e2e9e6;\r\n  white-space: nowrap;\r\n}\r\n\r\n.partner-demo-page .table-partner tbody tr {\r\n  border-bottom: 1px solid #e2e9e6;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.partner-demo-page .table-partner tbody tr:hover {\r\n  background: #f8faf9;\r\n}\r\n\r\n.partner-demo-page .table-partner tbody td {\r\n  padding: 0.875rem 1rem;\r\n  color: #2d3d38;\r\n  vertical-align: middle;\r\n}\r\n\r\n.partner-demo-page .badge-partner {\r\n  display: inline-block;\r\n  padding: 0.25rem 0.625rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  border-radius: 6px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.partner-demo-page .badge-partner.badge-success {\r\n  background: #e8f5ef;\r\n  color: #0d5c3a;\r\n}\r\n\r\n.partner-demo-page .badge-partner.badge-warning {\r\n  background: #fef8e8;\r\n  color: #8a6a1e;\r\n}\r\n\r\n.partner-demo-page .badge-partner.badge-info {\r\n  background: #e8f2f5;\r\n  color: #1a5f7a;\r\n}\r\n\r\n.partner-demo-page .badge-partner.badge-secondary {\r\n  background: #eef1f0;\r\n  color: #5a6b64;\r\n}\r\n\r\n.partner-demo-page .badge-partner.badge-danger {\r\n  background: #fce8e8;\r\n  color: #a32a2a;\r\n}\r\n\r\n.partner-demo-page .btn-partner-primary {\r\n  background: #1f7c50;\r\n  border-color: #1f7c50;\r\n  color: #fff;\r\n  font-weight: 500;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 8px;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.partner-demo-page .btn-partner-primary:hover {\r\n  background: #1a6b44;\r\n  border-color: #1a6b44;\r\n  color: #fff;\r\n}\r\n\r\n.partner-demo-page .btn-partner-outline {\r\n  border: 1px solid #c5d4d0;\r\n  color: #2d3d38;\r\n  font-weight: 500;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 8px;\r\n  font-size: 0.875rem;\r\n  background: #fff;\r\n}\r\n\r\n.partner-demo-page .btn-partner-outline:hover {\r\n  background: #f1f5f4;\r\n  border-color: #a8bdb5;\r\n  color: #1a2522;\r\n}\r\n\r\n.partner-demo-page .stat-card {\r\n  background: #fff;\r\n  border: 1px solid #e2e9e6;\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  box-shadow: 0 1px 3px rgba(26, 37, 34, 0.06);\r\n  height: 100%;\r\n}\r\n\r\n.partner-demo-page .stat-card.stat-success {\r\n  border-left: 4px solid #1f7c50;\r\n}\r\n\r\n.partner-demo-page .stat-card .stat-label {\r\n  font-size: 0.8125rem;\r\n  color: #5a6b64;\r\n  font-weight: 500;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.partner-demo-page .stat-card .stat-value {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  color: #1a2522;\r\n}\r\n\r\n.partner-demo-page .stat-card .stat-meta {\r\n  font-size: 0.8125rem;\r\n  color: #5a6b64;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.partner-demo-page .quick-link-card {\r\n  display: block;\r\n  text-decoration: none;\r\n  background: #fff;\r\n  border: 1px solid #e2e9e6;\r\n  border-radius: 10px;\r\n  padding: 1rem 1.25rem;\r\n  margin-bottom: 0.5rem;\r\n  color: #2d3d38;\r\n  font-weight: 500;\r\n  transition: border-color 0.2s ease, background 0.2s ease;\r\n}\r\n\r\n.partner-demo-page .quick-link-card:hover {\r\n  border-color: #1f7c50;\r\n  background: #f8faf9;\r\n  color: #1a2522;\r\n}\r\n\r\n.partner-demo-page .activity-item {\r\n  padding: 0.75rem 0;\r\n  border-bottom: 1px solid #e2e9e6;\r\n  font-size: 0.9375rem;\r\n  color: #2d3d38;\r\n}\r\n\r\n.partner-demo-page .activity-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.partner-demo-page .activity-item .activity-time {\r\n  font-size: 0.8125rem;\r\n  color: #5a6b64;\r\n  margin-top: 0.2rem;\r\n}\r\n\r\n.partner-demo-page .form-label-partner {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  color: #2d3d38;\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.partner-demo-page .form-control-partner {\r\n  border: 1px solid #c5d4d0;\r\n  border-radius: 8px;\r\n  padding: 0.5rem 0.75rem;\r\n  font-size: 0.9375rem;\r\n}\r\n\r\n.partner-demo-page .form-control-partner:focus {\r\n  border-color: #1f7c50;\r\n  box-shadow: 0 0 0 3px rgba(31, 124, 80, 0.15);\r\n}\r\n\r\n.partner-demo-page .cert-card {\r\n  background: #fff;\r\n  border: 1px solid #e2e9e6;\r\n  border-radius: 10px;\r\n  padding: 1.25rem;\r\n  height: 100%;\r\n  box-shadow: 0 1px 3px rgba(26, 37, 34, 0.06);\r\n}\r\n\r\n.partner-demo-page .cert-card .cert-name {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #1a2522;\r\n  margin-bottom: 0.75rem;\r\n  padding-bottom: 0.5rem;\r\n  border-bottom: 1px solid #e2e9e6;\r\n}\r\n\r\n.partner-demo-page .cert-card .cert-detail {\r\n  font-size: 0.875rem;\r\n  color: #5a6b64;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.partner-demo-page .cert-card .cert-detail strong {\r\n  color: #2d3d38;\r\n  font-weight: 500;\r\n}\r\n\r\n.partner-demo-page .list-item-partner {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0.875rem 1rem;\r\n  border-bottom: 1px solid #e2e9e6;\r\n  font-size: 0.9375rem;\r\n}\r\n\r\n.partner-demo-page .list-item-partner:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.partner-demo-page .section-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #1a2522;\r\n  margin: 0 0 1rem 0;\r\n}\r\n\r\n.partner-demo-page .demo-badge {\r\n  font-size: 0.6875rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  color: #5a6b64;\r\n  background: #eef1f0;\r\n  padding: 0.2rem 0.5rem;\r\n  border-radius: 4px;\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.partner-demo-page .partner-brief {\r\n  background: #e8f5ef;\r\n  border: 1px solid #c5e6d4;\r\n  color: #1a2522;\r\n}\r\n\r\n.partner-demo-page .partner-brief strong {\r\n  color: #0d5c3a;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
